/**
 * Inbox refresh without Supabase Realtime.
 *
 * TanStack Query `refetchInterval` issues plain REST reads on a timer.
 * Polling pauses automatically when the browser tab is hidden (unless
 * refetchIntervalInBackground is enabled). Cost is bounded: one open
 * conversation is ~12 requests/minute (messages every 5s, thread list
 * every 15s), vs a persistent Realtime channel per client.
 */
export const SHOP_INBOX_MESSAGES_POLL_MS = 5_000;
export const SHOP_INBOX_THREADS_POLL_MS = 15_000;
/** Global toast watcher — slightly faster than thread list in inbox. */
export const SHOP_INBOX_NOTIFY_POLL_MS = 10_000;

export const shopInboxPollQueryOptions = {
  refetchOnWindowFocus: true,
  refetchIntervalInBackground: false,
} as const;

/**
 * Poll options for the global notification watcher.
 *
 * Differs from {@link shopInboxPollQueryOptions}: we keep polling while the
 * tab is hidden so that browser notifications can fire when the user is on
 * another tab. The cost is one extra REST read every
 * {@link SHOP_INBOX_NOTIFY_POLL_MS} per backgrounded tab — bounded and small,
 * comparable to a Realtime keepalive.
 */
export const shopInboxNotifyPollQueryOptions = {
  refetchOnWindowFocus: true,
  refetchIntervalInBackground: true,
} as const;
